<template>
	<div class="content body_height">
		<div class="fbx" v-if="list.length != 0">
			<h2 class="">用户协议</h2>
			<div class="fbxc">

				<div class="fbxlist" v-for="(item,index) in list" :key="index">
					<div class="fbx_t">
						{{index+1}}、{{item.title}}
					</div>
					<div class="fbx_c">{{item.introduce}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'footagree',
		data() {
			return {
				list: []
			};
		},
		created() {
			this.getlist()
		},
		methods: {
			async getlist() {
				const res = await this.$axios.get('/front/listNews', {
					pageNum: '',
					pageSize: '',
					categoryName: this.$route.query.service
				})
				this.list = res.rows
			}
		}
	}
</script>

<style scoped lang="scss">
	.fbx {
		background-color: var(--white);
		margin: 16px 0;
		border-radius: 10px;


		h2 {
			border-bottom: 1px solid var(--border);
			font-weight: normal;
			font-size: 16px;
			padding: 20px;
			color: var(--tips);
		}

		.fbxc {
			padding: 20px;

			.fbxlist {
				margin-bottom: 20px;
				border-bottom: 1px solid var(--border);
				padding-bottom: 20px;

				.fbx_t {
					font-size: 16px;
					font-weight: bold;
				}

				.fbx_c {
					color: var(--tips);
					margin-top: 4px;
				}

				&:last-child {
					border: none;
					margin-bottom: 0;
					padding-bottom: 0;
				}
			}
		}
	}
</style>
